<basic-uploader [uploaderId]="fileUploaderId + '-uploader'"
                  [uploadManager]="storageUploadManager"
                  [validType]="fileType"
                  [fileList]="canvaUploadList"
                  [shown]="isUploading">
</basic-uploader>
